import { Injectable } from '@angular/core';
import { Action } from "../model/action";
//import { Organization } from "../model/organization";
import { Corporate } from 'app/section/user/model/corporate';
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { HttpClientService } from "../../../shared/service/http/http-client.service";
import { CookiesService } from "../../../shared/service/cookies/cookies.service";
import { concatStatic } from 'rxjs/operator/concat';
@Injectable()
export class CorporateService {
  http: HttpClientService;
  cookie: CookiesService;
  objAction: Action;
  data: Corporate;
  constructor(http: HttpClientService, cook: CookiesService) { 
    this.http = http;
    this.cookie = cook;
    this.objAction = new Action(this.http, this.cookie);
  }
  saveCorporate(): Observable<Corporate> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/patient/CreateCorporate";
    return this.objAction.save();
  }
  updateCorporate(): Observable<Corporate> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Organization/updateOrganization";
    return this.objAction.update();
  }
 getAllCorporate(): Observable<Corporate[]> {
    this.objAction.path = "api/patient/GetAllCorporate";
    return this.objAction.get();
  }
  deleteCorporate(corp: Corporate): Observable<Corporate> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/patient/deleteCorporatebyId/" + corp?.TAP_AUTOID;
    return this.objAction.delete();
  }
  activeCorporate(corp: Corporate): Observable<Corporate> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/patient/activeCorporate/" + corp?.TAP_AUTOID;
    return this.objAction.delete();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/section/master/services/corporate.service.ts